export default __webpack_public_path__ + "static/media/ShareNetwork.d1fd50b0.svg";